var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCodeSnippetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_525_177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.95337 2.02254H4.29386L0 7.777L4.29386 13.5315H6.95337L2.65951 7.777L6.95337 2.02254ZM12.0466 2.02254H14.7061L19 7.777L14.7061 13.5315H12.0466L16.3405 7.777L12.0466 2.02254ZM10.8499 0.00619835L11.7714 0.225161C11.9167 0.259817 12.0064 0.407892 11.974 0.555967L8.49496 15.7872C8.46094 15.9337 8.31559 16.0267 8.17025 15.9936L7.25024 15.7746C7.1049 15.74 7.01522 15.5919 7.04769 15.4438L10.5267 0.212559C10.5607 0.0660586 10.7061 -0.0268823 10.8499 0.00619835Z",
    fill: "#3B0532"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_525_177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeSnippetIcon);
export default __webpack_public_path__ + "static/media/code-snippet-icon.001169fc0d7cbea6b8fffb65b02f841d.svg";
export { ForwardRef as ReactComponent };